/** @format */
import { css } from 'styled-components';

import { theme } from '@toucan/config/theme';

import { smallTablet } from '@toucan/helpers/media-queries';

import { CategoryListSectionProps } from './index';

/**
 * Base styles for the category list section component
 *
 * @param {CategoryListSectionProps} props The category list section properties object
 * */
const baseStyles = (props: CategoryListSectionProps) => css`
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    align-self: start;
    padding: 0 var(--layout-spacing-24) var(--layout-spacing-24);

    h4 {
        margin-bottom: var(--layout-spacing-24);
        /* Font size for heading should always be 1.6rem at all viewport sizes*/
        font-size: 1.6rem;

        &.category-list-title {
            font-weight: 600;
        }
    }

    ul {
        display: flex;
        flex-direction: column;
        position: relative;
        margin: 0;
        padding: 0;

        li {
            display: flex;
            list-style-type: none;
            padding: 0;
            margin: 0;
            align-items: center;
            justify-content: space-between;

            a {
                padding: var(--layout-spacing-12) 0;
            }

            &:first-of-type {
                a {
                    padding: 0 0 var(--layout-spacing-12) 0;
                }
            }

            .brand-logo {
                justify-self: center;

                svg {
                    width: 100%;
                    margin-bottom: 2rem;
                    fill: var(--colors-text-secondary);
                    transition: 0.15s fill ease-in-out;

                    &:hover {
                        fill: var(--colors-text-primary);
                    }
                }
            }

            .subcategory-link {
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;

                svg {
                    width: 0.5em;
                    height: 0.5em;
                }
            }
        }
    }

    .back-button {
        ${theme.typography.body_normal_highlight}

        > span {
            display: flex;
            align-items: center;
        }

        .icon {
            margin-right: var(--layout-spacing-12);
        }
    }

    .show-all-link-container h4.show-all-link {
        padding: 1.4rem 0;

        ${smallTablet(css`
            // calculate how much space the toolbar is using so we can
            // add offset margin-bottom
            margin-bottom: calc(100lvh - 100svh + var(--layout-spacing-32));
        `)}
    }
`;

/**
 * Subcategory styles for the category list section component
 *
 * @param {CategoryListSectionProps} props The category list section properties object
 * */
const subcategoryStyles = ({ isSubcategory }: CategoryListSectionProps) => {
    if (isSubcategory) {
        return css`
            background: var(--colors-surface-primary);
            height: 100%;
        `;
    }

    return css``;
};

/**
 * The category list section component styles
 *
 * @param {CategoryListSectionProps} props The category list section properties object
 * */
export const styles = (props: CategoryListSectionProps) => css`
    ${baseStyles(props)}
    ${subcategoryStyles(props)}
`;
